<template>
  <div class="scoreddetails">
    <div class="mydetails m-4 flex ">
      <div class="w-1/4 bg-grid-color-secondary h-12 px-2">
        <vx-card title="企业文化考核详情" class="top" style="max-width: 450px;">
          <div style="display: flex;justify-content: space-between;">
            <vs-breadcrumb
                :items="[{title: '待评分考核',url: '/admin/scored'},{title: '考核',active: true}]"></vs-breadcrumb>
            <router-link :to="{path:'/admin/scoredtable',query:{id:id}}">
              <vs-button color="primary" type="filled">切换表格状态</vs-button>
            </router-link>
          </div>
        </vx-card>
        <br/>
        <vs-sidebar static-position default-index="1">
          <div class="header-sidebar" slot="header">
            <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
              <vs-avatar size="70px" color="primary" text="龙翔" style="font-size: 17px;"/>
              <h5>{{ user.userName }}({{ user.phone }})</h5>
              <h5 class="mb-4 mt-2">{{ user.deptName }}</h5>
            </div>
            <h4>企业文化考核项</h4>
            <p class="mt-4 text-danger" style="font-size: 16px;">当前总评分：<span>{{ grade }}</span></p>
          </div>
          <div class="px-6 py-4" v-for="(item,index) in info" :key="item.dimension">
            <h5>{{ rpBig(index + 1) + '.' + item.dimension }}</h5>
            <div class="flex mt-6 cursor-pointer" :class="isselect==index&&isitem==i?'text-primary':''"
                 v-for="(t,i) in item.templateInfoVo" :key="i" @click="getItem(index,i,t)">
              <span class="text-lg ml-3">{{ t.number }}.{{ t.behaviors }}
                <em class="text-danger">(评分：{{ t.leaderScore }})</em></span>
            </div>
          </div>
        </vs-sidebar>
      </div>
      <div class="w-3/4 bg-grid-color h-12 px-2" v-if="info && !(current.dimensionType === 5)">
        <vx-card :title="current.behaviors" class="p-10" style="min-height:75vh">
          <div class="item">
            <p class="mb-4"><span class="text-warning">行为标准：</span>{{ current.standards }}</p>
            <p class="mb-4"><span class="text-warning">举证突出：</span>{{ current.prominentEvidence }}</p>
            <p class="mb-4"><span class="text-warning">评分标准：</span>{{ current.markingCriterion }}</p>
          </div>
          <vs-divider/>
          <div class="vx-col w-full flex" style="align-items: center;">
            <el-tooltip popper-class="popper" class="item" effect="dark" placement="top-start">
              <div slot="content">
                <pre>{{ current.firstMonthEvidence }}</pre>
              </div>
              <i class="el-icon-warning-outline"></i>
              <p>上月填写内容示例</p>
            </el-tooltip>
          </div>
          <div class="mt-5">
            <el-descriptions title="填报内容" :column="1" border>
              <el-descriptions-item label="行为佐证" label-class-name="detailslabel">{{ current.evidence || '无' }}
              </el-descriptions-item>
              <el-descriptions-item label="佐证来源" label-class-name="detailslabel">
                {{ current.evidenceSource || '无' }}
              </el-descriptions-item>
              <el-descriptions-item label="自评分" label-class-name="detailslabel">
                <el-tag size="small">{{ current.selfEvaluation }}分</el-tag>
              </el-descriptions-item>
            </el-descriptions>
            <vs-divider/>
            <form>
              <div class="vx-row">
                <div class="vx-col w-full mt-4">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>我的评语</span>
                      </div>
                    </template>
                    <vs-textarea v-model="current.remarks" contenteditable="true"/>
                  </vx-input-group>
                </div>
                <div class="vx-col w-full mt-4">
                  <vx-input-group class="mb-base flex items-center">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary mr-10">
                        <span>我的评分</span>
                      </div>
                    </template>
                    <ul class="centerx flex items-center">
                      <el-radio-group v-model="current.leaderScore">
                        <el-radio :label="c" v-for="(c,p) in current.optionalScore" :key="p">{{ c }}分</el-radio>
                      </el-radio-group>
                    </ul>
                  </vx-input-group>
                </div>
              </div>
              <div class="vx-col w-full mt-4 flex">
                <vs-button type="filled" @click.prevent="submitForm" class="mt-5 mr-6 block">保存</vs-button>
                <vs-button type="filled" color="success" @click.prevent="next" class="mt-5 block">下一条</vs-button>
              </div>
            </form>
          </div>
        </vx-card>
      </div>

      <div class="w-3/4 bg-grid-color h-12 px-2" v-if="info && (current.dimensionType === 5)">
        <vx-card :title="current.behaviors" class="p-10" style="min-height:75vh">
          <div class="item">
            <p class="mb-4"><span class="text-warning">评分标准：</span>{{ current.markingCriterion }}</p>
          </div>
          <vs-divider/>
          <div class="mt-5">
            <form>
              <div class="vx-row">
                <div class="vx-col w-full mt-4">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-danger">
                        <span>评分人佐证</span>
                      </div>
                    </template>
                    <vs-textarea v-model="current.remarks" contenteditable="true"/>
                  </vx-input-group>
                </div>
                <div class="vx-col w-full mt-4">
                  <vx-input-group class="mb-base flex items-center">
                    <template slot="prepend">
                      <div class="prepend-text bg-danger mr-10">
                        <span>扣分</span>
                      </div>
                    </template>
                    <ul class="centerx flex items-center">
                      <el-radio-group v-model="current.leaderScore">
                        <el-radio label="0">0分</el-radio>
                        <el-radio label="-1">-1分</el-radio>
                        <el-radio label="-2">-2分</el-radio>
                        <el-radio label="-3">-3分</el-radio>
                        <el-radio label="-4">-4分</el-radio>
                        <el-radio label="-5">-5分</el-radio>
                      </el-radio-group>
                    </ul>
                  </vx-input-group>
                </div>
              </div>
              <div class="vx-col w-full mt-4 flex">
                <vs-button type="filled" @click.prevent="submitForm" class="mt-5 mr-6 block">保存</vs-button>
                <vs-button type="filled" color="success" @click.prevent="next" class="mt-5 block">下一条</vs-button>
              </div>
            </form>
          </div>
        </vx-card>
      </div>
    </div>

  </div>

</template>
<script>
import {nowtime, rp} from "../../../utils/format"

export default {
  data() {
    return {
      user: '',
      id: '',
      info: '',
      delScoreFlag: false,
      isselect: 0,   //选择的维度
      isitem: 0,     //选择的项
      current: '',   //当前选择项内容
      grade: 0,      //总评分
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("userdetails"));
    this.id = this.$route.query.id;
    this.getdetails();
  },
  watch: {
    current: {
      handler(newvalue, oldvalue) {
        console.log("你在作甚", newvalue, oldvalue);
        this.info[this.isselect].templateInfoVo[this.isitem] = newvalue;
        this.getgrade();
      },
      deep: true
    }
  },
  methods: {
    rpBig(num) {
      return rp(num);
    },
    submitForm() {     //保存标准
      const that = this;

      var obj = [];
      obj = JSON.parse(JSON.stringify(that.info));
      for (var i = 0; i < obj.length; i++) {
        for (var j = 0; j < obj[i].templateInfoVo.length; j++) {
          obj[i].templateInfoVo[j].optionalScore = obj[i].templateInfoVo[j].optionalScore.toString();
        }
      }

      this.$api.scoresave(obj, {'content-type': 'application/json'}).then(function (response) {
        console.log("保存结果：", response);
        if (response.code == 0) {
          that.$vs.notify({
            title: "提示",
            color: 'success',
            text: response.message,
            position: 'top-center'
          });
        } else {
          that.$vs.notify({
            title: "提示",
            color: 'warning',
            text: response.message,
            position: 'top-center'
          });
        }
      })
    },
    next() {
      console.info("current", this.current.leaderScore);
      if ((this.current.leaderScore == 15 || this.current.leaderScore == 16 || this.current.leaderScore == 17 ||
          this.current.leaderScore == 24 || this.current.leaderScore == 25) && !this.current.remarks) {
        console.info(this.current.leaderScore);
        this.$vs.notify({
          title: "提示",
          color: 'warning',
          text: "最低分、最高分区间需 ”我的评语“ 佐证",
          position: 'top-center'
        });
        return;
      }
      if (this.isselect <= this.info.length - 1 && this.isitem < this.info[this.isselect].templateInfoVo.length - 1) {
        console.log(111);
        this.isitem = this.isitem + 1;
        this.current = this.info[this.isselect].templateInfoVo[this.isitem];
      } else if (this.isselect < this.info.length - 1 && this.isitem == this.info[this.isselect].templateInfoVo.length - 1) {
        console.log(222);
        this.isitem = 0;
        this.isselect = this.isselect + 1;
        this.current = this.info[this.isselect].templateInfoVo[this.isitem];
      } else if (this.isselect == this.info.length - 1 && this.isitem == this.info[this.isselect].templateInfoVo.length - 1) {
        this.$vs.notify({
          title: "提示",
          color: 'warning',
          text: "没有下一条了~",
          position: 'top-center'
        });
      } else {
        this.$vs.notify({
          title: "提示",
          color: 'warning',
          text: "没有下一条了~",
          position: 'top-center'
        });
      }
    },
    getItem(index, i, item) {		//一项的内容
      this.isselect = index;
      this.isitem = i;
      this.current = item;
      console.log("该项内容", index, item);
    },
    getgrade() {			//计算自评总分
      var that = this;
      that.grade = 0;
      for (var i = 0; i < that.info.length; i++) {
        for (var j = 0; j < that.info[i].templateInfoVo.length; j++) {
          that.info[i].templateInfoVo[j].leaderScore = that.info[i].templateInfoVo[j].leaderScore.toString();
          that.info[i].delScoreFlag = that.info[i].dimensionType == 5;
          that.grade = parseInt(that.grade) + parseInt(that.info[i].templateInfoVo[j].leaderScore);
          try{
            that.info[i].templateInfoVo[j].optionalScore = that.info[i].templateInfoVo[j].optionalScore ? that.info[i].templateInfoVo[j].optionalScore.split(",") : [];
          } catch (e) {}
        }
      }
    },
    getdetails() {   //获取详情
      const that = this;
      this.$api.scoredetails({id: that.id}).then(function (response) {
        console.log("详情：", response);
        if (response.code == 0) {
          that.info = response.data;
          that.current = that.info[that.isselect].templateInfoVo[that.isitem];
          that.getgrade();
        } else {
          that.$vs.notify({
            title: "提示",
            color: 'warning',
            text: response.message,
            position: 'top-center'
          });
        }
      })
    },
  },
}
</script>
<style type="text/css">
.scoreddetails .parentx-static {
  overflow: hidden;
  height: 500px;
  position: relative;
}

.scoreddetails .header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.scoreddetails h4 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.scoreddetails h5 {
  font-weight: 600;
}

.scoreddetails .vs-sidebar--background {
  background: none !important;
  max-width: 450px !important;
  width: auto !important;
}

.scoreddetails .vs-sidebar .vs-sidebar--items {
  max-height: 65vh !important;
  overflow: auto !important;
}

.myculture .vs-sidebar--items {
  -ms-overflow-style: none !important; /* IE 10+ */
  scrollbar-width: none !important; /* Firefox */
}

::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.scoreddetails .vs-sidebar {
  max-width: 450px;
}

.scoreddetails .item {
  font-size: 16px;
}

.scoreddetails .el-radio__input.is-checked + .el-radio__label {
  color: #7367F0 !important;
  transform: scale(1.2);
}

.scoreddetails .el-radio__input.is-checked .el-radio__inner {
  background: #7367F0 !important;
  border-color: #7367F0 !important;
  transform: scale(1.5);
}

.detailslabel {
  width: 120px
}
</style>
